import { HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpHandlerFn } from "@angular/common/http"
import { Observable, catchError, from, mergeMap, throwError } from "rxjs"

export const intercept = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
    return next(req).pipe(
        catchError(err => {
            if (err instanceof HttpErrorResponse &&
                err.error instanceof Blob &&
                err.error.type === 'application/json') {
                return from(err.error.text()).pipe(
                    mergeMap(text => throwError(() => ({
                        ...err,
                        error: JSON.parse(text),
                    }))),
                )
            }
            return throwError(() => err)
        }),
    )
}